export const PREREGISTER_OPEN_EVENT = "relayrigs-open-preregister";

export const openPreRegister = (segment = "driver", presetState = null) => {
  window.dispatchEvent(new CustomEvent(PREREGISTER_OPEN_EVENT, { detail: { segment, presetState } }));
};
